<template>
  <div class="divider">
    <div class="divider-line">
      <h3 class="divider-title">{{title}}</h3>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Divider',
  data() {
    return {
      title: '',
    };
  },
  mounted() {
    const ex = this.$extension;
    this.title = ex.parameters.instance.title;
  },
};
</script>

<style scoped lang="scss">
  .divider {
    height: 45px;
    display: flex;
    align-items: center;

    .divider-line {
      flex: 1;
      border-bottom: 2px solid rgb(45, 47, 49);
      margin-bottom: 15px;

      .divider-title {
        font-size: 24px;
        padding: 0;
        margin: 0 0 8px 6px;
      }
    }
  }
</style>
